import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import { ImFilePdf, ImImage, ImFileWord, ImFileExcel } from "react-icons/im";
import axios from "axios";
import { FadeLoader } from "react-spinners";
import { API_BASE_URL } from "../../config/api";

const CATEGORY_ID = 27;

const NastavniProces = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);

        let allPosts = [];
        let totalPages = 1;
        let page = 1;

        while (page <= totalPages) {
          const response = await axios.get(
            `${API_BASE_URL}/posts&categories=${CATEGORY_ID}&_fields=id,title,date,acf&acf_format=standard&per_page=${recordsPerPage}&page=${page}`
          );

          allPosts = allPosts.concat(response.data);
          totalPages = Number(response.headers["x-wp-totalpages"] || 1);
          page++;
        }

        // najnoviji prvi
        allPosts.sort((a, b) => new Date(b.date) - new Date(a.date));

        setData(allPosts);
        setFilter(allPosts);
      } catch (error) {
        console.error("Greška prilikom dohvata:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  const nPages = Math.ceil(filter.length / recordsPerPage);

  const requestSearch = (searchedVal) => {
    const q = (searchedVal ?? "").toString().toLowerCase();

    if (!q) {
      setFilter(data);
      setCurrentPage(1);
      return;
    }

    const filteredRows = data.filter((row) =>
      (row?.title?.rendered ?? "").toLowerCase().includes(q)
    );

    setFilter(filteredRows);
    setCurrentPage(1);
  };

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filter.slice(indexOfFirstRecord, indexOfLastRecord);

  return (
    <div className="container drugaSekcija dekanat">
      <div className="container dekanat">
        <div className="container drugaSekcija">
          <h1>Nastavni proces</h1>

          {loading ? (
            <div
              className="text-center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "70vh",
              }}
            >
              <FadeLoader color="#123abc" loading={loading} />
            </div>
          ) : (
            <div className="d-flex bd-highlight">
              <div className="p-2 flex-fill bd-highlight">
                <TextField
                  onChange={(e) => requestSearch(e.target.value)}
                  placeholder="Traži dokument"
                  fullWidth
                  margin="normal"
                />

                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>Naziv dokumenta</TableCell>
                        <TableCell>Datum objave</TableCell>
                        <TableCell>Preuzmi</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {currentRecords.map((row, index) => (
                        <TableRow key={row.id}>
                          <TableCell>{indexOfFirstRecord + index + 1}</TableCell>
                          <TableCell>{row?.title?.rendered || "—"}</TableCell>
                          <TableCell>
                            {row?.date ? new Date(row.date).toLocaleDateString() : "—"}
                          </TableCell>

                          <TableCell>
                            {row?.acf?.dokumenti?.length
                              ? row.acf.dokumenti.map((el) => {
                                  const url = el?.dokument?.url;
                                  const subtype = el?.dokument?.subtype;

                                  if (!url) return null;

                                  let Icon = null;
                                  if (subtype === "pdf") Icon = ImFilePdf;
                                  else if (["jpeg", "jpg", "png"].includes(subtype))
                                    Icon = ImImage;
                                  else if (["doc", "docx"].includes(subtype))
                                    Icon = ImFileWord;
                                  else if (
                                    subtype ===
                                      "vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                                    subtype === "vnd.ms-excel" ||
                                    subtype === "xls" ||
                                    subtype === "xlsx"
                                  )
                                    Icon = ImFileExcel;

                                  return (
                                    <a
                                      key={el?.naziv_dokumenta || url}
                                      href={url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ marginRight: 8 }}
                                    >
                                      {Icon ? <Icon size={22} /> : "Dokument"}
                                    </a>
                                  );
                                })
                              : "—"}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {nPages > 1 && (
                  <Pagination
                    count={nPages}
                    page={currentPage}
                    onChange={(_, value) => setCurrentPage(value)}
                    style={{ marginTop: 16 }}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NastavniProces;
